var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-group"},[_c('span',{staticClass:"nav-group-header"},[_c('icon',_vm._b({staticClass:"mr-1"},'icon',{ icon: _vm.icon, iconType: _vm.iconType },false)),_c('span',{staticClass:"group-title"},[_vm._v(_vm._s(_vm.title))])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }